<template>
  <div id="app">
    <searchsidebar @show-search="showSearch"></searchsidebar>
    <!-- <header-bar></header-bar> -->
    <menu-sidebar></menu-sidebar>

    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"></router-view>
    </transition>

    <footer-bar></footer-bar>

    <podcast-player></podcast-player>
  </div>
</template>

<script>

'use strict'

/* eslint-disable */
// import HeaderBar from "@/components/HeaderBar"
import FooterBar from "@/components/FooterBar"
import MenuSidebar from "@/components/MenuSidebar"
import PodcastPlayer from "@/components/PodcastPlayer"

let data = {}

export default {
  name: "App",
  data() { return data },
  components: {
    // "header-bar": HeaderBar,
    "footer-bar": FooterBar,
    "menu-sidebar": MenuSidebar,
    "podcast-player": PodcastPlayer
  },
  methods: {
    testme() {
      // call using this.$parent.testme()
      console.log(`APP testme!!`)
    },
    showSearch() {
      alert('show search')
    },
  },
  created() {
    // console.log(`APP created`)
  },
  mounted() {
    // console.log(`APP mounted`)
  }
}
</script>

<style>
body {
  background-color: #f3f4f9;  /* light gray background */
}

#app {
  background-color: #f3f4f9;  /* light gray background */
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 60px;
}

.div-section-header {
  /* border: 1px solid #77F; */
  background-color: #f3f4f9;
  margin: 15px 5px 10px 0;
}

.div-section-body {
  padding: 1px 0px 0px 10px;
  background-color: #FFF;
  border: 1px solid #DDD;
}

.div-section-ad {  /* no background */
  padding: 1px 0px 0px 10px;
  /* background-color: #FFF; */
  /* border: 1px solid #DDD; */
}

.div-padding {
  padding: 10px 5px 10px 5px;
}

.txt-section-title {
  font-weight: bold;
  color: black;
  font-size: 1.2rem;
}
.txt-section-subtitle {
  font-weight: bold;
  color: #3471b3;;
  font-size: .9rem;
}

.txt-blog-featured {
  position: relative;  /* these 2 lines nudge text center up */
  top: -2px;
  padding: 2px 3px;
  margin-right: 4px;
  font-weight:normal;
  font-size:9px;
  background-color:#2165af;
  color:white;
}

.divPlayerApp {
    z-index: 100;
    background-color: #FFF;
    margin: 5px auto 0 auto;
    position: fixed;
    /* position: sticky; */
    /* left: 20px; */
    bottom: 0;
}

.divPlayerApp2 {
    padding: 5px 20px;
    border: 2px solid gray;
}

.page-header h2 {
  font-size: 1.1em;
  color: white;
  background-color: black;
  padding: 10px 0px;
  text-align: center;
}

.class-title {
   font-size: .9rem;
   font-weight: bold;
}
.class-author {
   font-size: .9rem;
   font-weight: normal;
}
.class-details {
  font-size: .71rem;
}

.txt-class-blurb {
  font-size: .95rem;
}

.pointer {
   cursor: pointer;
}

.red {
  color: red;
}

.reserved {  /* subtitle under photo */
  font-size: .7rem;
  font-weight: bold;
  letter-spacing: 1px;
  color: white;
  background-color: rgba(255, 0, 0, 1.0);;
  margin: 0 auto;
  max-width: 150px;
}

.waitlist {  /* subtitle under photo */
  font-size: .7rem;
  font-weight: bold;
  letter-spacing: 1px;
  color: white;
  background-color: #3471b3;
  margin: 0 auto;
  max-width: 150px;
}

.completed {  /* subtitle under photo */
  font-size: .7rem;
  font-weight: bold;
  letter-spacing: 1px;
  color: white;
  background-color: #3471b3;
  margin: 0 auto;
  max-width: 150px;
}


/* transitions */

.fade-enter-to {
  opacity: 1;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .4s ease-out;
}

.fade-leave-to {
  opacity: 0;
}

/* misc */
.col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12 {
  /* border: 1px solid #ccc; */
  font-size: auto;
}

</style>



// WEBPACK FOOTER //
// src/App.vue